var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/Board/BoardPositions/index.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import pt from 'prop-types';
import { times } from 'ramda';
import { fretWidth } from './../../../../../lib/fretboard';
import Position from './../../../../Fretboard/Neck/Position';
import Wrapper from './Wrapper';

const positions = (tuning, nrOfFrets) => n => {
  const width = fretWidth(nrOfFrets)(n);
  const pos = n + 1; // set 1st position to 1, not 0

  return /*#__PURE__*/React.createElement(Position, _extends({
    key: `pos-${pos}`
  }, {
    tuning,
    width,
    pos
  }, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 10
    }
  }));
};

const BoardPositions = ({
  tuning,
  nrOfFrets
}) => /*#__PURE__*/React.createElement("foreignObject", {
  width: "100%",
  height: "100%",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 16,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement(Wrapper, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 17,
    columnNumber: 5
  }
}, times(positions(tuning, nrOfFrets), nrOfFrets)));

BoardPositions.propTypes = {
  tuning: pt.arrayOf(pt.string).isRequired,
  nrOfFrets: pt.number.isRequired
};
export default BoardPositions;
